import { render } from "./AiConfig.vue?vue&type=template&id=bee68fc0&scoped=true"
import script from "./AiConfig.vue?vue&type=script&lang=js"
export * from "./AiConfig.vue?vue&type=script&lang=js"

import "./AiConfig.vue?vue&type=style&index=0&id=bee68fc0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bee68fc0"]])

export default __exports__